export function toDate(value) {
  if (!value) return null;
  if (typeof value.toDate === "function") return value.toDate();
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatRunDate(value) {
  const date = toDate(value);
  return date ? date.toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "Date unavailable";
}

export function runPathIds(run) {
  return run?.config?.path_ids || run?.path_ids || [];
}

export function estimateMonitoringRequest(durationMinutes, pollingIntervalSeconds, paths) {
  const samplesPerPath = Math.floor((durationMinutes * 60) / pollingIntervalSeconds) + 1;
  const googleRequests = paths.reduce(
    (total, path) => total + samplesPerPath * (path.points?.length || 0) * 2,
    0,
  );
  return { samplesPerPath, googleRequests };
}

export function durationLabel(seconds) {
  if (!Number.isFinite(Number(seconds))) return "—";
  const total = Math.round(Number(seconds));
  const minutes = Math.floor(total / 60);
  const remainder = total % 60;
  return minutes ? `${minutes}m ${remainder}s` : `${remainder}s`;
}

export function sampleSeriesData(samples, viewKey = "whole") {
  return samples.map((sample) => {
    const source = viewKey === "whole"
      ? sample.whole_path
      : sample.segments?.[Number(viewKey)];
    if (!source) return null;
    const live = Number(source.live_duration_seconds);
    const liveBaseline = Number(source.live_baseline_duration_seconds);
    const future = Number(source.one_week_duration_seconds);
    const futureBaseline = Number(source.one_week_baseline_duration_seconds);
    return {
      date: toDate(sample.sampled_at),
      sampleIndex: sample.sample_index,
      liveMinutes: live / 60,
      liveBaselineMinutes: liveBaseline / 60,
      futureMinutes: future / 60,
      futureBaselineMinutes: futureBaseline / 60,
      livePercent: Number.isFinite(Number(source.live_traffic_delay_percent))
        ? Number(source.live_traffic_delay_percent)
        : liveBaseline ? ((live - liveBaseline) / liveBaseline) * 100 : null,
      futurePercent: Number.isFinite(Number(source.one_week_traffic_delay_percent))
        ? Number(source.one_week_traffic_delay_percent)
        : futureBaseline ? ((future - futureBaseline) / futureBaseline) * 100 : null,
    };
  }).filter((row) => row?.date);
}

